<template>
  <q-card square @click="$emit('click')">
    <div class="row">
      <transition
        enter-active-class="animated animate__fadeIn"
        leave-active-class="animated animate__fadeOut"
        mode="out-in"
        appear=""
        :duration="200"
      >
        <div
          v-if="!loading"
          class="col text-h6 text-weight-bold text-accent q-pa-md"
        >
          <div class="text-caption text-grey-8">Ramp</div>
          {{ ramp.names.join(', ') }}
        </div>
        <div v-else class="col q-pl-md q-pt-sm" style="height: 84px">
          <q-skeleton type="text" width="50px" height="20px" />
          <q-skeleton type="text" width="100px" height="50px" />
        </div>
      </transition>
      <slot />
    </div>
  </q-card>
</template>

<script lang="ts">
import { Ramp } from '@/types/ramp'
import { defineComponent, PropType } from 'vue'

export default defineComponent({
  name: 'Ramp',

  emits: ['click'],

  props: {
    ramp: {
      type: Object as PropType<Ramp>,
    },
    loading: Boolean,
  },
})
</script>
